import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { T7eService } from '../../../t7e/t7e.service';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { PrecalcPopupData } from '../precalc-popup/precalc-popup.component';
import { config } from '../../../config';

@Component({
  selector: 'app-warn-too-many-conseq-workdays-popup',
  templateUrl: './warn-too-many-conseq-workdays-popup.component.html',
  styleUrls: ['./warn-too-many-conseq-workdays-popup.component.scss']
})
export class WarnTooManyConseqWorkdaysPopupComponent implements OnInit {
  private readonly t7e = inject(T7eService)

  @Input() days$: BehaviorSubject<PrecalcPopupData[]> = new BehaviorSubject<PrecalcPopupData[]>([]);
  /** 
   * Ez jelzi a hívó komponens felé, hogy a felhasználó választott valamit 
   * Erre tud várni await-tel */
  @Output() userAction: EventEmitter<boolean> = new EventEmitter<boolean>()
  
  ALLOW_WORK_ON_REST_DAY = config.ALLOW_WORK_ON_REST_DAY
  isWorkOnRestdayPreapproved$ = new BehaviorSubject<boolean>(false)
  
  constructor() { }

  ngOnInit(): void {
    console.assert(this.days$.value.every(day => day.conttsidcnt !== undefined), 'Minden day-nek kell, hogy legyen conttsidcnt-je a popupban')
  }

  onConfirmed() {
    this.userAction.emit(true)
  }

  onCancelled(): void {
    this.userAction.emit(false)
  }

  toggleWorkOnRestdayPreapproved(isChecked: boolean) {
    this.isWorkOnRestdayPreapproved$.next(isChecked)
  }


  readonly componentName = 'app-warn-too-many-conseq-workdays-popup'
  t7ePopupWorkOnRestdayTitle = this.t7e.getTranslation(this.componentName, 'popup-work-on-restday', 'title', null, null, 'Túl sok egybefüggő munkanap')
  // azért get, hogy az onInit után fusson le
  get t7eWorkOnRestdayExplanationText() {
    return this.t7e.replaceVar(this.t7e.getTranslation(
      this.componentName, 'work-on-restday-preapproved-message', this.ALLOW_WORK_ON_REST_DAY ? 'allowed' : 'notAllowed', null, null
      , `Ez már a(z) {0}. folyamatos munkanap pihenőnap nélkül.`)
      , Math.max(...this.days$.value.map(day => day.conttsidcnt ?? 0))
    )
  }

}
